import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Grid, useMediaQuery } from "@mui/material";
import { IoIosArrowForward } from "react-icons/io";
import toast from "react-hot-toast";

import { LoadPlans, CreatePurchase, CreatePurchaseDirect, CreatePurchaseWhilePromo } from "../../../redux/v2/plan/actions";
import { LoadAccountDetails } from "../../../redux/v2/user/actions";
import { calculateDateFromTrialPeriodFormat } from "../../../constants";
import { SetModalProperties, ShowModal } from "../../../redux/v2/utils/actions";
import { ScreenType } from "../../../utils/breakpoints";

import CustomModalWrapper from "../../../common/CustomModalV2/wrapper";
import CustomApplePayButton from "../../../common/CustomApplePayButton";
import CustomGooglePayButton from "../../../common/CustomGooglePayButton";
import CustomButton from "../../../common/CustomButton";
import PBCardDetails from "../components/PBCardDetails";
import Logout from "../../../common/Logout";
import IndiPlans from "../components/IndiPlans";
import PromoCode from "../components/PromoCode";
import PurchaseFormFooter from "../components/PurchaseFormFooter";

import "./style.css";

function PlanBilling(props) {
    const { withHeader = true, withCustomModal = true } = props;
    const { billing } = props.User;

    const navigate = useNavigate();
    const screenSize = ScreenType(useMediaQuery);

    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedPlan, setSelectedPlan] = useState({});
    const [filteredPlan, setFilteredPlan] = useState([]);
    const expired = localStorage.getItem("expired");
    const offer = searchParams.get("offer");

    const toDisplayPlans = expired
        ? {
            // this one is sign up for existing user with no live subscription redirected to chosing plan
            plans: ["monthly-renewal", offer == 1 ? "discount-annual-trial" : offer == 2 ? "discount-annual" : "annual-plan-renewal"],
            label: ["MONTHLY", "ANNUAL"],
            term: ["Month", "Year"],
        }
        : {
            // this one is signup for new user
            plans: ["monthly-free-trial", offer == 1 ? "discount-annual-trial" : offer == 2 ? "discount-annual" : "annual-free-trial"],
            label: ["MONTHLY", "ANNUAL"],
            term: ["Month", "Year"],
        };

    useEffect(() => {
        props.LoadPlans();
    }, []);

    useEffect(() => {
        if (billing?.hasLiveSubscription) {
            navigate("/");
        }
    }, [billing]);

    useEffect(() => {
        if (props.Plan.plans.length > 0) {
            let filtered = [];
            let selected = null;
            props.Plan.plans
                .sort((a, b) => b.interval_length - a.interval_length)
                ?.map((plan) => {
                    let planIndex = toDisplayPlans.plans.indexOf(plan.code);
                    if (planIndex > -1) {
                        filtered.push(plan);
                        if (filtered.length === 1) {
                            selected = plan;
                        }
                    }
                });
            setSelectedPlan(selected);
            setFilteredPlan(filtered);
            localStorage.setItem("current-selected-plan", JSON.stringify(selected));
        }
    }, [props.Plan.plans]);

    const postPurchase = async (toastId, formDetails = null) => {
        const res2 = await props.LoadAccountDetails();

        props.ShowModal(false);
        toast.success("Plan subscribed successfully", {
            id: toastId,
        });

        localStorage.setItem("requirement_status", 3);
        localStorage.setItem("survey_not_done", true);
        localStorage.setItem("access-token", localStorage.getItem("temp-access-token"));
        localStorage.removeItem("temp-access-token");

        if (formDetails) {
            localStorage.setItem(
                "indi-new-user-details",
                JSON.stringify({
                    name: {
                        first: formDetails?.firstName,
                        last: formDetails?.lastName,
                    },
                })
            );
        }

        navigate("/");
    };

    const onSubmit = async ({ err, token, formDetails, toastId }) => {
        if (err) {
            if (err?.message) {
                var lastIndex = err.message.lastIndexOf(" ");
                let str = err.message.substring(0, lastIndex);
                let errmessage = str + " " + err.details[0].field;
                toast.error(errmessage, {
                    id: toastId,
                });
            }
        } else {
            let couponArr = [];
            let coupon_code = localStorage.getItem("coupon_code");
            let createPurchaseObj = {
                first_name: formDetails?.firstName,
                last_name: formDetails?.lastName,
                currency: "USD",
                rjs_token: token.id,
                plan_id: selectedPlan.id,
                billing_zip: formDetails?.postalCode,
                coupon_code: couponArr,
                renewal: false,
            };

            let res = await props.CreatePurchase(createPurchaseObj, selectedPlan);

            if (res.status == 200) {
                postPurchase(toastId, formDetails);
            } else {
                toast.dismiss(toastId);
            }
        }
    };

    const onSubmitUsingApplePay = async (token) => {
        const toastId = toast.loading("Creating purchase...");

        let coupon_code = localStorage.getItem("coupon_code") || [];
        let createPurchaseObj = {
            currency: "USD",
            rjs_token: token.id,
            plan_id: selectedPlan.id,
            coupon_code: coupon_code,
        };

        let res = await props.CreatePurchaseDirect(createPurchaseObj, selectedPlan);

        if (res.status == 200) {
            postPurchase(toastId);
        } else {
            toast.dismiss(toastId);
        }
    };

    const onSubmitUsingGooglePay = async (token) => {
        const toastId = toast.loading("Creating purchase...");

        let coupon_code = localStorage.getItem("coupon_code") || [];

        const plan = JSON.parse(localStorage.getItem("current-selected-plan"));

        let createPurchaseObj = {
            currency: "USD",
            rjs_token: token.id,
            plan_id: plan.id,
            coupon_code: coupon_code,
        };

        let res = await props.CreatePurchaseDirect(createPurchaseObj, plan);

        if (res.status == 200) {
            postPurchase(toastId);
        } else {
            toast.dismiss(toastId);
        }
    };

    let trialEnd = calculateDateFromTrialPeriodFormat(selectedPlan?.trial_length, selectedPlan?.trial_unit);
    const dt = localStorage.getItem("indi-device-type");

    return (
        <>
            <div id="plan-billing" className="plan-v2-css">
                {withHeader && <Logout showLogo />}

                <div id="plan-billing-banner" hidden={screenSize == "xl"}>
                    {/* <img src="/assets/images/choose-plan-banner.jpg" className="Choose Plan Banner" /> */}
                </div>
                <Grid id="pbb-main-grid" container spacing={0} style={{ paddingTop: "60px" }}>
                    <Grid item xs={screenSize != "xl" ? 12 : 5} style={{ display: "flex", justifyContent: "center" }}>
                        <div style={{ maxWidth: "450px" }}>
                            <div id="plan-billing-banner-text">
                                <h3>Start Your Free Trial</h3>
                                <p>Both plans include two weeks free and can be cancelled at any time.</p>
                            </div>
                            <div className="auth-box" style={{ padding: "0 30px 50px 30px" }}>
                                <div className="container">
                                    <IndiPlans
                                        plans={filteredPlan}
                                        selectedPlan={selectedPlan}
                                        setSelectedPlan={setSelectedPlan}
                                        promoCodeArea={
                                            billing?.currentPlan?.code != "promo" && (
                                                <div id="promo-code-banner">
                                                    <h5
                                                        onClick={() => {
                                                            props.SetModalProperties({
                                                                isShow: true,
                                                                title: "",
                                                                height: "320px",
                                                                body: (
                                                                    <>
                                                                        <PromoCode
                                                                            type="new"
                                                                            close={() => {
                                                                                props.ShowModal(false);
                                                                            }}
                                                                        />
                                                                    </>
                                                                ),
                                                                actions: [],
                                                            });
                                                        }}
                                                    >
                                                        Enter Promo Code <IoIosArrowForward />
                                                    </h5>
                                                </div>
                                            )
                                        }
                                    />

                                    <h4>CHOOSE PAYMENT METHOD</h4>

                                    <div id="card-payment-div">
                                        <CustomButton
                                            onClick={() => {
                                                props.SetModalProperties({
                                                    isShow: true,
                                                    title: "",
                                                    body: (
                                                        <>
                                                            <PBCardDetails
                                                                selectedPlan={selectedPlan}
                                                                callback={(response) => {
                                                                    onSubmit({
                                                                        ...response,
                                                                    });
                                                                }}
                                                            />
                                                        </>
                                                    ),
                                                    actions: [],
                                                });
                                            }}
                                        >
                                            Pay with Credit Card
                                        </CustomButton>
                                    </div>

                                    {
                                        dt === "ios" && (
                                            <div id="payment-provider-div">
                                                <CustomApplePayButton
                                                    plan={selectedPlan}
                                                    applePayCallButtonback={(token) => {
                                                        onSubmitUsingApplePay(token);
                                                    }}
                                                />
                                            </div>
                                        )
                                    }

                                    <div id="payment-provider-div">
                                        <CustomGooglePayButton
                                            plan={selectedPlan}
                                            googlePayCallButtonback={(token) => {
                                                onSubmitUsingGooglePay(token);
                                            }}
                                        />
                                    </div>

                                    <PurchaseFormFooter selectedPlan={selectedPlan} endDate={trialEnd} />
                                </div>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={7}>
                        <div id="plan-billing-banner" hidden={screenSize != "xl"} style={{ height: "100%" }}>
                            <img src="/assets/images/choose-plan-banner.jpg" className="Choose Plan Banner" style={{ height: "100%", objectFit: "cover" }} />
                        </div>
                    </Grid>
                </Grid>
            </div>

            {withCustomModal && <CustomModalWrapper />}
        </>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Plan: state.Plan,
});

export default connect(mapStateToProps, {
    LoadPlans,
    CreatePurchaseDirect,
    CreatePurchase,
    CreatePurchaseWhilePromo,
    SetModalProperties,
    ShowModal,
    LoadAccountDetails,
})(PlanBilling);
